import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Session } from '../services/session';
import { SmartLoadBoardFeatureFlagService } from '@services/feature-flags/smart-load-board';

interface ILoadboardSettingsGuard {
  redirectTo?: string;
}

@Injectable()
export class LoadboardSettingsGuard {
  constructor(
    private router: Router,
    private session: Session,
    private smartLoadBoardFeatureFlagService: SmartLoadBoardFeatureFlagService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.session.isSLBOptOut() || this.smartLoadBoardFeatureFlagService.isSlbAccessShutdownEnabled()) {
      const loadboardSettingsGuard: ILoadboardSettingsGuard = route.data.loadboardSettingsGuard;
      const redirectTo = loadboardSettingsGuard.redirectTo || '/';
      this.router.navigate([redirectTo]);
      return false;
    }
    return true;
  }
}
